import React, { FC } from 'react';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { Divider } from 'antd';

require('./TwoLineList.less');

export const TwoLineList: FC<any> = ({ listItems, lineOneRender, lineTwoRender }) => {
	return (
		<div className="twoLineList">
			{listItems &&
				listItems.map((listItem, idx) => (
					<AccessPermissionChecker key={idx} name={listItem.accessPermissionName}>
						<div className="twoLineList__listItem">
							<div className="twoLineList__firstLine">{lineOneRender(listItem)}</div>
							<div className="twoLineList__secondLine">{lineTwoRender(listItem)}</div>
							<Divider style={{ margin: 0, marginTop: 4 }} />
						</div>
					</AccessPermissionChecker>
				))}
		</div>
	);
};
